import { useDispatch, useSelector } from "react-redux"
import RawArticle from "../../articles/RawArticle"
import PanelLoading from "../../PanelLoading"
import { selectIsLoading, selectArticles, updateArticle } from "../../../reducers/notificationPanelArticlesSlice"
import NotificationListItem from "./NotificationListItem"
import ImportedArticle from "../../articles/ImportedArticle"
import {
	selectFilteredNotificationsForCurrentPanelView,
} from "../../../reducers/notificationsSlice"
import SwitchWSModal from "./SwitchWSModal"
import NotificationsScrollControlPanel from "./NotificationsScrollControlPanel"
import {useMemo} from "react"
import {useWorkspaceContext} from "../../../pages/Dashboard"
import {useUnassignedArticleIds} from "../../../hooks/MemoizedSelectors"

export default function NotificationPanel() {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const articles = useSelector((state) => selectArticles(state, workspaceId))
	const isLoading = useSelector((state) => selectIsLoading(state, workspaceId))
	const unassignedArticleIds = useUnassignedArticleIds()
	const normalizedNotifications = useMemo( () => selectFilteredNotificationsForCurrentPanelView(workspaceId), [workspaceId])
	const normalizedNotificationsForSelectedInboxView = useSelector((state) => normalizedNotifications(state))
	const setArticleAsImported = (article) => { dispatch(updateArticle(article)) }

	return (
		<>
			{isLoading && (
				<PanelLoading />
			)}
			<SwitchWSModal />
			{!isLoading && (
				<NotificationsScrollControlPanel>
					{
						!(articles.length > 0) && (
							<>
								{
									normalizedNotificationsForSelectedInboxView.map((data, index) => (
										<NotificationListItem
											key={data.userName + index}
											sharedCitationObject={data}
										/>
									))
								}
							</>
						)
					}
					{
						(articles.length > 0) && (
							<div>
								<div>
									{
										articles.map((sharedArticle, index) => {
											const isDeleted = !!sharedArticle.deletedAt
											if (sharedArticle.articleId && !isDeleted) {
												return (
													<ImportedArticle
														key={sharedArticle.articleId}
														articleWorkspace={sharedArticle}
														isUnassigned={unassignedArticleIds.includes(sharedArticle.articleId)}
														index={index}
													/>
												)
											} else {
												const rawArticleObject = isDeleted ? sharedArticle.article : sharedArticle
												return(
													<RawArticle
														key={rawArticleObject.PMID || rawArticleObject.DOI || rawArticleObject.ISBN || rawArticleObject.ARXIVID || rawArticleObject.id}
														article={rawArticleObject}
														index={index}
														deletedAt={isDeleted}
														setArticleAsImported={setArticleAsImported}
													/>
												)
											}
										})
									}
								</div>
							</div>
						)
					}
				</NotificationsScrollControlPanel>
			)}

		</>
	)
}